<header class="sidebar-header">
  <mat-icon class="sidebar-header-icon" svgIcon="planning-blue"></mat-icon>
  <h3 class="sidebar-header-title" vdw-ellipsis-label [text]="getFormTitle()" matTooltipPosition="above"></h3>
  <button mat-icon-button class="mat-icon-action-button-sm-without-border" (click)="closeMachineDetail()" type="button">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</header>

@if (createItemMode) {
  <mat-radio-group class="flex gap-16" [class.flex-column]="!isWide" [value]="getSelectedItemType()" (change)="selectedItemTypeChanged($event)">
    @for (maintenanceType of maintenanceTypes; track maintenanceType) {
      <mat-radio-button [value]="maintenanceType">
        {{ 'PLANNING.ADD_ITEM.TYPES.' + maintenanceType | bmsTranslate }}
      </mat-radio-button>
    }
    <mat-radio-button [value]="'RUN'">
      {{ 'PLANNING.ADD_ITEM.TYPES.RUN' | bmsTranslate }}
    </mat-radio-button>
  </mat-radio-group>
}
@if (planningItem.type === 'MAINTENANCE') {
  <app-maintenance-sidebar></app-maintenance-sidebar>
} @else if (planningItem.type.startsWith('ORDER')) {
  <app-planning-order-sidebar></app-planning-order-sidebar>
} @else if (planningItem.type.startsWith('RUN')) {
  <app-planning-run-sidebar></app-planning-run-sidebar>
} @else if (planningItem.type === 'FIXED_SCHEDULE_PLACEHOLDER') {
  <app-fixed-schedule-placeholder-sidebar></app-fixed-schedule-placeholder-sidebar>
}
